import { Row, Col } from "../../App.styles";

const Text = () => {
  return (
    <>
      <Row>
        <Col>
          <p>Complete by: Text</p>
        </Col>
      </Row>
    </>
  );
};

export default Text;
